import { commonService } from '.';

const updateGoal = (id, body) => {
    return commonService.post('Goal?id=' + id, body);
};

const insertGoal = (body) => {
    return commonService.post('Goal', body);
};

const deleteGoal = (id, idEa) => {
    return commonService.deleteWithParam('Goal?id=' + id + '&idEa=' + idEa, null);
};

export const goalService = {
    updateGoal,
    insertGoal,
    deleteGoal
};